import { useRef } from 'react';
import Navigation from '../navigation/Navigation';
import { Container, StickyWrapper } from './Topbar.styles';
import { useIntersectionObserver } from '../../../ui';

interface IProps {
	siteSectionId?: string;
}

export function Topbar({ siteSectionId }: IProps) {
	const ref = useRef<HTMLDivElement>(null);
	const intersect = useIntersectionObserver(ref, {
		threshold: 1,
	});
	const isSticky = intersect?.isIntersecting === false;

	return (
		<Container ref={ref}>
			{/* Fixed on top */}
			<StickyWrapper isSticky={isSticky}>
				<Navigation siteSectionId={siteSectionId} isSticky={isSticky} />
			</StickyWrapper>
		</Container>
	);
}
